import * as ApiNames from 'self-service-api/constants/ApiNames';

const displayAddOnLimitIncreaseCopy = apiName => {
  const addOnsWithCopyOverrides = [ApiNames.ADS_LIMIT_INCREASE, ApiNames.CALLING_LIMIT_INCREASE, ApiNames.CUSTOM_SSL, ApiNames.ESIGNATURE_LIMIT_INCREASE, ApiNames.PHONE_LIMIT_INCREASE, ApiNames.REPORTING_LIMIT_INCREASE, ApiNames.VIDEO_LIMIT_INCREASE, ApiNames.WHATSAPP_LIMIT_INCREASE, ApiNames.WORKFLOWS_LIMIT_INCREASE];
  return addOnsWithCopyOverrides.includes(apiName);
};

export default displayAddOnLimitIncreaseCopy;